import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = unknown;
export const schemaLoanRequestResolver_GetResubmissionCount = z.number();

export type SchemaLoanRequestResolver_GetResubmissionCount = z.infer<
    typeof schemaLoanRequestResolver_GetResubmissionCount
>;

export type LoanRequestResolver_GetResubmissionCount = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetResubmissionCount
>;
